import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    getPayout,
    getIsPayoutLoading,
    getPayoutErrorMessage
} from './payoutEntity';
import {
    getPayout as queryForPayout
} from './payoutActions';
import {
    EmvioCard,
    EmvioLoadingSpinner as LoadingSpinner,
    EmvioRow,
    EmvioTwoColumnItem
} from '@nexio/emvio-util-ui';
import {
    payoutShape
} from '../../utils/propTypes';
import {
    doesPropExistAndHasItChanged,
    payoutStatusMapper,
    payoutProviderMapper,
    transferStatusMapper,
    prettifyMoney
} from '@nexio/emvio-util-app';
import { toastIfError } from '../../utils/toast';
import ErrorCard from '../ErrorCard/ErrorCard';
import mixpanel from '../../utils/mixpanel';
import './Payout.scss';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';

export class Payout extends Component {
    static propTypes = {
        error: PropTypes.string,
        isPayoutLoading: PropTypes.bool,
        match: PropTypes.shape({
            isExact: PropTypes.bool,
            params: PropTypes.shape({
                id: PropTypes.string
            }),
            path: PropTypes.string,
            url: PropTypes.string
        }),
        onGetPayoutById: PropTypes.func,
        onGoBack: PropTypes.func,
        payout: payoutShape,
        onToggleModal: PropTypes.func,
        customAccess: PropTypes.any,
        payoutAccountMap: PropTypes.any
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.props.onGetPayoutById(this.props.match.params.id);
        mixpanel.track('Payout page mounted');
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props);

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'match.params.id')) {
            this.props.onGetPayoutById(this.props.match.params.id);
        }
    }

    renderPayoutResult = () => {
        const items = [
            {
                label: 'Payout Status',
                value: _.startCase(payoutStatusMapper[_.get(this.props.payout, 'payoutStatus')])
            },
            {
                label: 'Transfer Status',
                value: _.startCase(transferStatusMapper[_.get(this.props.payout, 'transferStatus')])
            },
            {
                label: 'Payout Provider Reference Number',
                value: _.get(this.props.payout, 'payoutProviderRef')
            },
            {
                label: 'Payout Provider Additional Reference Number',
                value: _.get(this.props.payout, 'payoutProviderAdditionalRef')
            },
            {
                label: 'Provider Response',
                value: _.get(this.props.payout, 'providerResponse')
            }
        ];

        return this.renderCard(items, 'Payout Results');
    };

    renderPayoutInfo = () => {
        const items = [
            {
                label: 'Payout ID',
                value: _.get(this.props.payout, 'id')
            },
            {
                label: 'Batch Ref',
                value: _.get(this.props.payout, 'batchRef')
            },
            {
                label: 'Amount',
                value: _.get(this.props.payout, 'amount') ? prettifyMoney(_.get(this.props.payout, 'amount')) : null
            },
            {
                label: 'Currency',
                value: _.get(this.props.payout, 'currencyId')
            },
            {
                label: 'Description',
                value: _.get(this.props.payout, 'description')
            },
            {
                label: 'Date Attempted',
                value: _.get(this.props.payout, 'payoutDate')
            },
            {
                label: 'Payout Ref',
                value: _.get(this.props.payout, 'payoutRef')
            },
            {
                label: 'Payout Account ID',
                value: _.get(this.props.payout, 'payoutAccountId')
            },
            {
                label: 'Payout Account Name',
                value: this.props.payoutAccountMap[_.get(this.props.payout, 'payoutAccountId')]
            }
        ];

        return this.renderCard(items, 'Payout Information');
    };

    renderRecipient = () => {
        const items = [
            {
                label: 'Recipient ID',
                value: _.get(this.props.payout, 'recipientId')
            },
            {
                label: 'Recipient Reference Number',
                value: _.get(this.props.payout, 'recipientRef')
            },
            {
                label: 'Email',
                value: _.get(this.props.payout, 'email')
            },
            {
                label: 'First Name',
                value: _.get(this.props.payout, 'firstName')
            },
            {
                label: 'Last Name',
                value: _.get(this.props.payout, 'lastName')
            },
            {
                label: 'Address Line 1',
                value: _.get(this.props.payout, 'addressLine1')
            },
            {
                label: 'Address Line 2',
                value: _.get(this.props.payout, 'addressLine2')
            },
            {
                label: 'City',
                value: _.get(this.props.payout, 'city')
            },
            {
                label: 'State / Region',
                value: _.get(this.props.payout, 'region')
            },
            {
                label: 'Postal Code',
                value: _.get(this.props.payout, 'postalCode')
            },
            {
                label: 'Country',
                value: _.get(this.props.payout, 'country')
            },
            {
                label: 'Phone Number',
                value: _.get(this.props.payout, 'phoneNumber')
            },
            {
                label: 'Mobile Number',
                value: _.get(this.props.payout, 'mobileNumber')
            }
        ];

        return this.renderCard(items, 'Recipient');
    };

    renderProvider = () => {
        const items = [
            {
                label: 'Provider ID',
                value: _.get(this.props.payout, 'providerId')
            },
            {
                label: 'Provider Type',
                value: _.startCase(payoutProviderMapper[_.get(this.props.payout, 'providerType')])
            },
            {
                label: 'Provider Recipient Reference Number',
                value: _.get(this.props.payout, 'providerRecipientRef')
            }
        ];

        return this.renderCard(items, 'Provider');
    };

    renderCard(items, headerTitle) {
        if (items.some((item) => (item.value))) {
            return (
                <EmvioCard className="half-width grow-height" HeaderComponent={headerTitle}>
                    {items.map((item) =>
                        <EmvioTwoColumnItem
                            key={item.label}
                            alterMethod={item.alterMethod}
                            label={item.label}
                            value={item.value}
                            breakAll={item.breakAll}
                        />
                    )}
                </EmvioCard>);
        } else {
            return null;
        }
    }

    render() {
        if (this.props.isPayoutLoading) {
            return (<LoadingSpinner />);
        } else if (this.props.payout && this.props.payoutAccountMap && !this.props.error) {

            let cards = [];
            cards.push(this.renderPayoutResult());
            cards.push(this.renderPayoutInfo());
            cards.push(this.renderRecipient());
            cards.push(this.renderProvider());
            cards = _.compact(cards);

            const cardRows = _.chunk(cards, 2).map((cardPair, index) => {
                return (
                    // eslint-disable-next-line @eslint-react/no-array-index-key
                    <EmvioRow key={index}>
                        {cardPair[0]}
                        {cardPair[1]}
                    </EmvioRow>
                );
            });

            return (
                <div className="emvio-payout">
                    {cardRows}
                </div>
            );
        } else {
            return (
                <div className="emvio-payout">
                    <EmvioRow>
                        <ErrorCard />
                    </EmvioRow>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        error: getPayoutErrorMessage(state),
        isPayoutLoading: getIsPayoutLoading(state),
        payout: getPayout(state),
        payoutAccountMap: getPayoutAccountsMapper(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetPayoutById: (id) => dispatch(queryForPayout(id))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Payout));
